export default "__VITE_ASSET__6b129bd4__"